import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { useGetAllPrintOptions } from '@Hooks/Documents';
import type { ApiPrintOption } from '@Model';
import { type Column, LoadingFrame, useTranslate } from '@synqo/frontend-component-library';
import { EnumFrontendLayoutSetting } from '@Model';
import { type FC } from 'react';

const printOptionColumns: Column<ApiPrintOption>[] = [{ name: 'display_string', label: 'Name' }];

export const FramePrintOptions: FC = () => {
    const i18n = useTranslate('');
    const { printOptions, isLoading, isError } = useGetAllPrintOptions();

    if (isLoading) {
        return <LoadingFrame />;
    } else if (isError) {
        return <div>{i18n('Fehler beim Laden der Ausdrucksoptionen. Bitte versuchen Sie es später noch einmal.')}</div>;
    }

    return (
        <TableWithStoredSettingsAndLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.PrintOptionsTableLayout}
            items={printOptions}
            name={'PrintOptionsList'}
            columns={printOptionColumns}
            canCreate={false}
            useOnClickNavigation
            fullSize
        />
    );
};
